// src/services/authService.js
import axios from 'axios';
import store from '../store';  // Import Vuex store
import router from '../router';


// Define the base URL of your Symfony API
const API_URL = process.env.VUE_APP_API_URL;

const authService = {
    login(userCredentials) {
        // Perform the login request
        return axios
            .post(`${API_URL}/login`, userCredentials)
            .then(response => {
                // If login is successful, store the token in local storage
                if (response.data.token) {
                    localStorage.setItem('token', response.data.token);

                    // Dispatch setIsLoggedIn with true
                    store.dispatch('setIsLoggedIn', true);
                    router.push('/main');

                }
                return response.data;
            })
            .catch(error => {
                console.error("Login failed", error);
                // Optionally, you could dispatch setIsLoggedIn(false) here if needed
                store.dispatch('setIsLoggedIn', false);
            });
    },

    logout() {
        // Remove the JWT token from local storage to log out
        localStorage.removeItem('token');

        // Dispatch setIsLoggedIn with false
        store.dispatch('setIsLoggedIn', false);
        router.push('/');

    },

    getToken() {
        // Get the stored JWT token from local storage
        return localStorage.getItem('token');
    },

    isAuthenticated() {
        // First, check if there is a token in localStorage
        const token = localStorage.getItem('token');

        if (!token) {
            // If no token exists, the user is not authenticated
            store.dispatch('setIsLoggedIn', false);  // Dispatch false if no token
            return false;
        }

        // Perform the token validation request asynchronously
        return axios.get(`${API_URL}/token/validate`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then(response => {
                // If the response is successful, the token is valid
                if (response.status === 200 && response.data.status === 'Token is valid') {
                    store.dispatch('setIsLoggedIn', true);  // Dispatch true if token is valid
                    return true;
                }
                store.dispatch('setIsLoggedIn', false);  // Dispatch false if token is not valid
                return false;
            })
            .catch(error => {
                // If there's an error (e.g., token expired), the user is not authenticated
                if (error.response && error.response.status === 401) {
                    store.dispatch('setIsLoggedIn', false);  // Dispatch false on token error
                    this.logout();
                    console.log('Token is invalid or expired');
                }
                return false;
            });
    }

};

export default authService;
